import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import * as xlsx from "xlsx";
var fileDownload = require("js-file-download");

//Not sure it really works. CORS policy between s3 and localhost & demo
File.getBase64FromURL = function (url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.send();
};
File.downloadFromUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, fileName) {
    var response, blob, finalFileName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch(url);
        case 3:
          response = _context.sent;
          if (response.ok) {
            _context.next = 6;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 6:
          _context.next = 8;
          return response.blob();
        case 8:
          blob = _context.sent;
          finalFileName = fileName || File.getFileNameFromUrl(url) || "download";
          fileDownload(blob, finalFileName);
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          console.error("Download failed:", _context.t0);
          window.open(url, "_blank");
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
File.getFileNameFromUrl = function (url) {
  try {
    var urlObj = new URL(url);
    var pathname = urlObj.pathname;
    var fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
    return fileName || null;
  } catch (error) {
    return null;
  }
};
File.transformSheetToJson = function (workbook) {
  var result = {};
  workbook.SheetNames.forEach(function (sheetName) {
    var roa = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName], {
      header: 1
    });
    if (roa.length) result[sheetName] = roa;
  });
  return result;
};
File.getFirstSheetName = function (wbJson) {
  for (var key in wbJson) {
    if (Array.isArray(wbJson[key])) {
      return key;
    }
  }
  return null;
};
File.isExtensionAllowed = function (filename, extensionsAllowed) {
  var ext = File.getExtension(filename);
  var sanitizedExtensions = extensionsAllowed.map(function (e) {
    return e.toLowerCase().replace(/^\./, "");
  });
  return sanitizedExtensions.includes(ext);
};
File.getExtension = function (filename) {
  if (typeof filename !== "string") {
    return "";
  }
  var parts = filename.split(".");
  if (parts.length <= 1) {
    return "";
  }
  return parts.pop().toLowerCase();
};
export default File;